import { GQL } from '@aline/graphql';
import { v4 as uuid4 } from 'uuid';

import type { InputFieldElement } from '../internal';
import { createDefaultText } from '../internal';

export function createDefaultNonSigField(): InputFieldElement {
  return {
    children: [createDefaultText()],
    fieldId: uuid4(),
    suggestedEdits: [],
    type: 'INPUT',
    variant: GQL.FieldVariant.Text,
  };
}
